/**
 * /tenant-records/$slug/administrators/invite — invite an administrator to a
 * tenant from its platform record. Where tenant creation lands (as the first
 * administrator), and where the Administrators tab's "Invite administrator"
 * goes. A platform control on the record, so it needs no tenant grant; the
 * invitation itself requires platform_admins.invite plus step-up. The loader
 * prefetches the RBAC catalog (immutable per deploy) and the roster, which
 * decides whether this is the first administrator. Thin route shim; the page
 * lives in features/tenants/.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchRBACCatalog } from "@/features/platform-admins/rbac-queries";
import { tenantAdminCensusOptions } from "@/features/tenants/queries";
import { InviteTenantAdminPage } from "@/features/tenants/pages/invite-tenant-admin-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenant-records/$slug/administrators/invite")({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData({
        queryKey: queryKeys.rbacCatalog,
        queryFn: fetchRBACCatalog,
        staleTime: Infinity,
      }),
      // A roster failure renders in the page's own error state.
      context.queryClient.ensureInfiniteQueryData(tenantAdminCensusOptions(context.record.id)).catch(() => undefined),
    ]);
    return null;
  },
  component: InviteTenantAdminPage,
});
